import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import ChecklistCard from "./ChecklistCard";

export default function YTMustRefer({ IsMLS }) {
  const [ReferralDocs, setReferralDocs] = useState([
    "eXp Referral Document",
    "MLS Sheet (Full Agent Detail View)",
  ]);

  useEffect(() => {
    if (IsMLS === "Exclusive") {
      setReferralDocs(["Referral Document"]);
    } else {
      setReferralDocs([
        "Referral Document",
        "MLS Sheet (Full Agent Detail View)",
      ]);
    }
  }, [IsMLS]);

  return (
    <>
      <div className="flex w-full pl-4 pt-3 items-center ">
        <div className="pb-5 pr-3">
          <div className="float-left mr-3 pt-2">
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              size="2xl"
              color="#cc0000"
            />
          </div>
          <div>
            You cannot represent both clients, or treat one as a customer, in a
            trade when you have direct interest in the listed property. As a
            result, you must release or refer one of the client(s) to another
            agent. However, you can collect a referral fee on the client
            referral.
          </div>
        </div>
      </div>

      <ChecklistCard
        CheckListData2={ReferralDocs}
        CheckListData={["Added to Deal Sheet"]}
        Header={"Referral"}
        Title2="Referral Documents (Outside Brokerage Listing)"
        Title1="Referral Documents (eXp Listing)"
        province="YT"
      />
    </>
  );
}
